import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  memberDetails: null,
};

const memberSlice = createSlice({
  name: "member",
  initialState,
  reducers: {
    setMemberDetails: (state, action) => {
      state.memberDetails = action.payload;
    },
  },
});

export const { setMemberDetails } = memberSlice.actions;

export default memberSlice.reducer;
